import React, { ReactElement } from "react";

/* ------------------------------------------------------------------ */
/* Local line glyphs (no DS equivalent), drawn with currentColor 24x24 */
/* ------------------------------------------------------------------ */

export type Glyph = (props: React.SVGProps<SVGSVGElement>) => ReactElement;

export const svgBase = {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  /* inline style beats the Button CSS "svg { fill: currentColor }", which
     would otherwise fill the closed shapes */
  style: { fill: "none" },
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/* 16px stroke glyphs for the formatting toolbars (the app uses lucide-react
   here, which the DS icon set doesn't cover) */
export const glyph16 = { ...svgBase, width: 16, height: 16, strokeWidth: 2 };

/* lucide Square = the plain "Rectangle" shape type */
export const SquareGlyph: Glyph = (props) => (
  <svg {...glyph16} {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
  </svg>
);

/* lucide Minus / Plus (stepper) */
export const MinusGlyph: Glyph = (props) => (
  <svg {...glyph16} {...props}>
    <path d="M5 12h14" />
  </svg>
);

export const PlusGlyph: Glyph = (props) => (
  <svg {...glyph16} {...props}>
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </svg>
);
